<template>
  <v-card>
    <v-toolbar color="primary" dark tabs>
      <!-- <v-toolbar-title>{{simplified.name}}</v-toolbar-title> -->
      <v-tabs v-model="tab" color="primary" slider-color="white" centered>
        <v-tab>{{ $tc('models.training') }}</v-tab>
        <v-tab :disabled="!simplified._id">
          {{ $tc('models.event', 2) }}
        </v-tab>
      </v-tabs>
      <v-spacer />
      <v-btn
        v-if="simplified._id"
        icon
        dark
        :loading="$store.state.trainings.loading"
        @click="$store.dispatch('trainings/fetchSimplified', simplified._id)"
      >
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn dark icon @click="cancel">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <v-progress-linear
        :active="loadingItem"
        height="3"
        :indeterminate="true"
        class="my-1"
      />
      <form-loader v-if="loadingItem" />
      <template v-else>
        <v-tabs-items v-model="tab">
          <v-tab-item ripple>
            <tab-view :training="simplified" />
          </v-tab-item>
          <v-tab-item ripple>
            <tab-events
              :training-id="simplified._id"
              :home-team-id="simplified.teamId ? simplified.teamId._id : ''"
              :location="simplified.location ? simplified.location._id : ''"
              :video="video"
              type-view="view"
            />
          </v-tab-item>
        </v-tabs-items>
      </template>
    </v-card-text>
    <!-- <v-divider></v-divider> -->
    <v-card-actions>
      <v-spacer />
      <meta-button type="cancel" @click="cancel" />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TabView from './view/TabView'
import TabEvents from '@/components/apps/matches/TabEvents'

export default {
  name: 'TrainingView',
  components: {
    TabView,
    TabEvents,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
      loadingItem: false,
    }
  },
  mounted() {
    if (this.id) {
      this.nextTick(() => {
        this.loadingItem = true
        this.fetchSimplified(this.id)
          .then(() => {
            this.setTab()
          })
          .catch(() => {
            this.cancel()
          })
          .finally(() => {
            this.loadingItem = false
          })
      })
    }
  },
  computed: {
    ...mapState({
      simplified: (state) => state.trainings.simplified,
      video: (state) => state.trainings.video,
    }),
  },
  methods: {
    ...mapActions({
      fetchSimplified: 'trainings/fetchSimplified',
      reset: 'trainings/reset',
    }),
    setTab() {
      switch (this.$route.params.tab) {
        case 'events':
          this.tab = 1
          break
        default:
          this.tab = 0
          break
      }
    },
    clear() {
      this.tab = 0
      this.reset()
    },
    cancel() {
      this.clear()
      let name = this.from && this.from.name ? this.from.name : 'trainings'
      this.$router.push({ name, params: { resetFilters: false } })
    },
  },
}
</script>
